import { Anchor, Group, Paper, Stack, Text, Title } from "@mantine/core";
import { IconExternalLink } from "@tabler/icons-react";

export const SettingsPage = () => {
  return (
    <Stack gap="md">
      <Title order={2}>Settings</Title>
      <Paper withBorder p="md" radius="md">
        <Stack gap="sm">
          <Text size="sm" fw={500}>
            Identity provider
          </Text>
          <Group gap="xs">
            <Text size="sm" c="dimmed">
              Managed by Authentik.
            </Text>
            <Anchor href="/auth/sign-in" size="sm" target="_blank" rel="noreferrer">
              <Group gap={4}>
                Authentik admin
                <IconExternalLink size={12} />
              </Group>
            </Anchor>
          </Group>
        </Stack>
      </Paper>
      <Paper withBorder p="md" radius="md">
        <Stack gap="xs">
          <Text size="sm" fw={500}>
            Session
          </Text>
          <Text size="sm" c="dimmed">
            Your ops session is valid for 8 hours and is bound to this browser.
          </Text>
          <Anchor component="a" href="/auth/logout" size="sm" c="red">
            Sign out
          </Anchor>
        </Stack>
      </Paper>
    </Stack>
  );
};
